import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left",
  "use": "icon-arrow_left-usage",
  "viewBox": "0 0 14 8.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 8.6\" id=\"icon-arrow_left\">\n<polygon points=\"0,4.3 6.5,8.6 6.5,4.8 14,4.8 14,3.8 6.5,3.8 6.5,0 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol